import React from 'react';
import { ColorModeContext } from './ColorModeContext';
const useColorMode = () => React.useContext(ColorModeContext);
export default useColorMode;
